import { useForm } from "react-hook-form";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { Button } from "@/components/ui/button";
import {
  Form,
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";

const scheduleFormSchema = z.object({
  name: z.string(),
  goal: z.string(),
});

export interface ScheduleFormV2Props {
  onSubmit: (values: z.infer<typeof scheduleFormSchema>) => void;
}

export const ScheduleFormV2 = ({
  onSubmit,
}: ScheduleFormV2Props): JSX.Element => {
  const form = useForm<z.infer<typeof scheduleFormSchema>>({
    resolver: zodResolver(scheduleFormSchema),
    defaultValues: {
      name: "",
      goal: "",
    },
  });

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-3">
        <FormField
          control={form.control}
          name="name"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Plan Name</FormLabel>
              <FormControl>
                <Input placeholder="Educational" {...field} />
              </FormControl>
              <FormDescription>
                This is the name of your content plan.
              </FormDescription>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="goal"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Plan Goal</FormLabel>
              <FormControl>
                <Input
                  placeholder="Educate people about content marketing."
                  {...field}
                />
              </FormControl>
              <FormDescription>
                This is the goal of your content plan.
              </FormDescription>
              <FormMessage />
            </FormItem>
          )}
        />

        <Button type="submit">Submit</Button>
      </form>
    </Form>
  );
};
